module.exports = __webpack_public_path__ + "static/media/10sec-countdown.504d4f07.mp3";